import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getLogLoginList } from '@blade-sxp/account/api/log';
let default_1 = class default_1 extends Vue {
    keyword;
    end_time;
    start_time;
    log_name = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    loading = false;
    filterName = [];
    logLoginList = [];
    multipleSelection = [];
    initI18n() {
        this.filterName = [
            { text: this.$t('login'), value: 'login' },
            { text: this.$t('logout'), value: 'logout' },
        ];
        this.getLogLoginList();
    }
    handleSelectionChange(selection) {
        this.multipleSelection = selection;
    }
    handleSizeChange(size) {
        this.pagination.size = size;
        this.getLogLoginList();
    }
    handleCurrentChange(current) {
        this.pagination.page = current;
        this.getLogLoginList();
    }
    handleClear() {
        this.$refs.multipleTable.clearSelection();
    }
    /**
     *@Description: 登录日志列表
     *@Date: 2020-09-07 15:54:36
     */
    getLogLoginList(search = false) {
        let data = {
            end_time: this.end_time,
            keyword: this.keyword,
            order: 1,
            log_name: this.log_name,
            page: search ? 1 : this.pagination.page,
            pageSize: this.pagination.size,
            start_time: this.start_time,
        };
        this.loading = true;
        getLogLoginList(data)
            .then((resp) => {
            if (resp.data.data.list.length > 0) {
                this.logLoginList = resp.data.data.list;
            }
            else {
                this.logLoginList = [];
                if (resp.data.data.totalPage > 1) {
                    this.pagination.page = resp.data.data.totalPage;
                    this.getLogLoginList();
                }
            }
            this.pagination.total = resp.data.data.total;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    filterChange(value) {
        const { login_type_str } = value;
        this.log_name = (login_type_str && login_type_str[0]) || '';
        this.getLogLoginList();
    }
    mounted() {
        this.getLogLoginList();
        this.initI18n();
    }
};
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Prop()
], default_1.prototype, "end_time", void 0);
__decorate([
    Prop()
], default_1.prototype, "start_time", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'LoginLog',
        i18n: {
            messages: {
                zh: {
                    login: '登入',
                    logout: '登出',
                },
                'en-us': {
                    login: 'Login',
                    logout: 'Logout',
                },
            },
        },
    })
], default_1);
export default default_1;
